import { MobileRedirect } from './MobileRedirect'

export { MobileRedirect }
